import React from 'react';
import SvgIcon from './SvgIcon';

const Details = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M17.029 21.558a4.529 4.529 0 100-9.058 4.529 4.529 0 000 9.058zM23.5 23.5l-3.248-3.248M4.5 8.5H14M4.5 11.5h6M4.5 5.5h7M4.5 14.5h4M4.5 17.5h4"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.5 23.5h-11a1 1 0 01-1-1v-21a1 1 0 011-1h13.293a1 1 0 01.707.293L19.207 4.5a1 1 0 01.293.707V9.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

Details.displayName = 'DetailsIcon';

export default Details;
